// generated from 6_274_248 samples

import { z } from "zod";
import { actionPathsStepGetSchema } from "./actionPathsStepGetSchema";
import { audiencePathsStepGetSchema } from "./audiencePathsStepGetSchema";
import { audienceSyncStepGetSchema } from "./audienceSyncStepGetSchema";
import { contentOptimizationStepGetSchema } from "./contentOptimizationStepGetSchema";
import { contextUpdateStepStepGetSchema } from "./contextUpdateStepStepGetSchema";
import { decisionSplitStepGetSchema } from "./decisionSplitStepGetSchema";
import { delayStepGetSchema } from "./delayStepGetSchema";
import { experimentStepGetSchema } from "./experimentStepGetSchema";
import { facebookAudienceSyncStepGetSchema } from "./facebookAudienceSyncStepGetSchema";
import { featureFlagStepGetSchema } from "./featureFlagStepGetSchema";
import { fullStepGetSchema } from "./fullStepGetSchema";
import { googleAudienceSyncStepGetSchema } from "./googleAudienceSyncStepGetSchema";
import { llmStepGetSchema } from "./llmStepGetSchema";
import { messageStepGetSchema } from "./messageStepGetSchema";
import { tiktokAudienceSyncStepGetSchema } from "./tiktokAudienceSyncStepGetSchema";
import { userCentricOptimizationStepGetSchema } from "./userCentricOptimizationStepGetSchema";
import { userUpdateStepGetSchema } from "./userUpdateStepGetSchema";
import { sendToDestinationStepGetSchema } from "./sendToDestinationStepGetSchema";

export const stepGetSchema = z.discriminatedUnion("type", [
  actionPathsStepGetSchema,
  audiencePathsStepGetSchema,
  audienceSyncStepGetSchema,
  contentOptimizationStepGetSchema,
  contextUpdateStepStepGetSchema,
  decisionSplitStepGetSchema,
  delayStepGetSchema,
  experimentStepGetSchema,
  facebookAudienceSyncStepGetSchema,
  featureFlagStepGetSchema,
  fullStepGetSchema,
  googleAudienceSyncStepGetSchema,
  llmStepGetSchema,
  messageStepGetSchema,
  sendToDestinationStepGetSchema,
  tiktokAudienceSyncStepGetSchema,
  userCentricOptimizationStepGetSchema,
  userUpdateStepGetSchema,
]);
